module.exports = __webpack_public_path__ + "img/46_27.9a6c5e2a.png";